<template lang="pug">
Tabs.purchase-list.pagination
    el-card.contains-table(shadow="always")
        PurchasesList
</template>

<script>
import Tabs from '@/extensions/shop/views/Partials/SalesTabs'
import PurchasesList from '@/components/PurchasesList'

import pinia from '@/pinia';
import { useShopPurchaseStore } from '@/stores';

export default {
    name: 'Purchases',
    components: {
        Tabs,
        PurchasesList
    },
    computed: {
        shopPurchaseStore() {
            return useShopPurchaseStore(pinia);
        },
    },
    methods: {
        resetPurchasesPaginated() {
            this.shopPurchaseStore.resetPurchasesPaginated();
        },
    },
    beforeDestroy() {
        this.resetPurchasesPaginated()
    }
}
</script>
